import Vue from 'vue'
import App from './App.vue'
import { BootstrapVue, IconsPlugin } from 'bootstrap-vue'
import axios from 'axios';

// Import Bootstrap and BootstrapVue CSS files (order is important)
import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'

Vue.config.productionTip = false

// Make BootstrapVue available throughout your project
Vue.use(BootstrapVue)
// Optionally install the BootstrapVue icon components plugin
Vue.use(IconsPlugin)

var server = "http://localhost:777"
if (process.env.NODE_ENV == "production") {
  server = "";
}

// io
async function get(url) {
  try {
    return await axios.get(url);
  } catch (e) {
    console.log("get => error : ", e)
  }
}
Vue.prototype.hGet = get;

async function post(url, data) {
  try {
    return await axios.post(url, data)
  } catch (e) {
    console.log("post => error : ", e)
  }
}
Vue.prototype.hPost = post;

async function getGridsList() {
  var t = await get(server + "/getGridsList");
  return t.data;
}
Vue.prototype.getGridsList = getGridsList;

async function getGrid(grid) {
  var t = await get(server + "/getGrid/" + grid);
  return t.data;
}
Vue.prototype.getGrid = getGrid;

async function postGrid(grid) {
  var t = await post(server + "/saveGrid/", grid);
  return t.data;
}
Vue.prototype.postGrid = postGrid;

async function renameGrid(oldName, newName) {
  var t = await get(server + "/renameGrid/" + oldName + "/" + newName);
  return t.data;
}
Vue.prototype.renameGrid = renameGrid;

new Vue({
  render: h => h(App),
}).$mount('#app')
